
import React, { Component } from 'react';
import { connect } from 'react-redux';

const pageName = "GiftCardList";

class GiftCardList extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render(){
        const p = this.props;
        return (
            <div>
                gift card list
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        branchId: state.common.branchId
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardList);